if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle
          .querySelector('.share-button__copy')
          .addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', this.share.bind(this));
        }
      }

      async share() {
        try {
          await navigator.share({ url: this.urlToShare, title: document.title });
        } catch (error) {
          // Closing the native share sheet is an expected user action, not an application error.
          if (error && error.name === 'AbortError') return;

          // If native sharing fails, keep the feature usable with the copy-link fallback.
          this.elements.shareButton.classList.add('hidden');
          this.mainDetailsToggle.removeAttribute('hidden');
          this.mainDetailsToggle.setAttribute('open', '');
          this.elements.shareSummary.setAttribute('aria-expanded', 'true');
          this.elements.urlInput.focus();
          this.elements.urlInput.select();
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      async copyToClipboard() {
        try {
          await navigator.clipboard.writeText(this.elements.urlInput.value);
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        } catch (error) {
          // Clipboard access can be denied by browser policy; leave the selected URL ready for manual copying.
          this.elements.urlInput.focus();
          this.elements.urlInput.select();
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
